import React from 'react'
import { useParams } from 'react-router-dom'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import { ExternalLinkIcon } from '../../pages/Activities/CitationPill'

import {
  ChangelogContainer,
  ChangelogHeader,
  ChangelogHeaderText,
  HeaderTopActions,
  ShowAllLink,
  Logs,
} from './Changelog.styles'
import { ChangelogPage } from './ChangelogPage'

export const Changelog = ({
  subjectmodelids,
  hideHeader = true,
  subjectIds,
  subjectType,
  isDashboardWidget: isWide,
}: {
  subjectmodelids?: string[]
  hideHeader?: boolean
  subjectIds?: string[]
  subjectType?: MODEL_TYPE
  isDashboardWidget?: boolean
}): JSX.Element => {
  const { pageContext } = useParams<{ pageContext?: string }>()

  const targetPath = pageContext ? `/${pageContext}/activities` : '/activities'

  const targetUrl = React.useMemo(() => {
    const searchParams = new URLSearchParams()
    let modelParamName = 'subject_model_id'
    let idParamName = 'subject_id'

    if (subjectType === MODEL_TYPE.POLICY) {
      modelParamName = 'citation_policy'
      idParamName = 'citation_policy'
    } else if (subjectType === MODEL_TYPE.CONTROL) {
      modelParamName = 'citation_control_id'
      idParamName = 'citation_control_id'
    } else if (subjectType === MODEL_TYPE.EVIDENCE) {
      modelParamName = 'citation_evidence'
      idParamName = 'citation_evidence'
    }

    if (subjectmodelids && subjectmodelids.length > 0) {
      subjectmodelids.forEach((id) => {
        if (!searchParams.getAll(modelParamName).includes(id)) {
          searchParams.append(modelParamName, id)
        }
        if (
          modelParamName !== 'subject_model_id' &&
          !searchParams.getAll('subject_model_id').includes(id)
        ) {
          searchParams.append('subject_model_id', id)
        }
      })
    }
    if (subjectIds && subjectIds.length > 0) {
      subjectIds.forEach((id) => {
        if (!searchParams.getAll(idParamName).includes(id)) {
          searchParams.append(idParamName, id)
        }
        if (
          idParamName !== 'subject_id' &&
          !searchParams.getAll('subject_id').includes(id)
        ) {
          searchParams.append('subject_id', id)
        }
      })
    }
    const queryString = searchParams.toString()
    return `${targetPath}${queryString ? `?${queryString}` : ''}`
  }, [targetPath, subjectmodelids, subjectIds, subjectType])

  return (
    <ChangelogContainer $isWide={isWide}>
      {hideHeader ? (
        <HeaderTopActions>
          <ShowAllLink
            href={targetUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            View activities log
            <ExternalLinkIcon />
          </ShowAllLink>
        </HeaderTopActions>
      ) : (
        <ChangelogHeader>
          <ChangelogHeaderText>Activities</ChangelogHeaderText>
          <ShowAllLink
            href={targetUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            View activities log
            <ExternalLinkIcon />
          </ShowAllLink>
        </ChangelogHeader>
      )}
      <Logs>
        <ChangelogPage
          itemsPerPage={20}
          subjectModelIds={subjectmodelids}
          subjectIds={subjectIds}
          subjectType={subjectType}
        />
      </Logs>
    </ChangelogContainer>
  )
}
